import { z } from 'zod';
import { BackendDeploymentStatus } from '@wix/ambassador-ctp-app-cloud-backend-service-v1-app-cloud-backend-deployment/types';

export const backendDeploymentStateSchema = z.object({
  appId: z.string(),
  deploymentUrl: z.string(),
  deploymentId: z.string(),
  status: z.enum([
    BackendDeploymentStatus.BACKEND_DEPLOYMENT_EMPTY,
    BackendDeploymentStatus.BACKEND_DEPLOYMENT_ERROR,
    BackendDeploymentStatus.BACKEND_DEPLOYMENT_IN_PROGRESS,
    BackendDeploymentStatus.BACKEND_DEPLOYMENT_SUCCESS,
  ]),
  error: z.string().optional(),
});
